import { ErrorSettingsHelper } from '../errors/settings'
import { ModeSettingsHelper } from '../settings'

export class AssurancesSettingsHelper extends ModeSettingsHelper {
  constructor(settings, modal) {
    super(settings)

    this.addIdsToSchemas(this._settings)

    if (this.isModeSettingProcessable('required')) {
      this._errors = new ErrorSettingsHelper(
        this._settings.required.error_settings,
        modal
      )
    }
  }
}
